module.exports = __webpack_public_path__ + "static/media/blrss6.d0dd1882.png";